import { render, staticRenderFns } from "./HiddenCosts.vue?vue&type=template&id=2aa74bd2&"
import script from "./HiddenCosts.vue?vue&type=script&lang=ts&"
export * from "./HiddenCosts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports